
import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import PropTypes from 'prop-types';


const Tdebug = false;

            
export class CustomError extends Error {
            
    constructor(message, errJson) {
      super(message);
      this.errJson = errJson;
      this.name = this.constructor.name;
    }       
}       

export class ApiRc {

    constructor() {
        //super();
    }
    
}   

export function SetSeo(allParams) {

    const params = allParams.seo;
    const schema = allParams.schema;
    
    Tdebug && console.log(params);
    Tdebug && console.log(schema);

    let title = params.title || '';
    let keywords = params.keywords || '';
    let canonicalUrl = params.canonicalUrl || '';
    let robots = params.robots || 'index, follow';
    let description = params.description || '';

    let ogType = params.ogType || 'website';
    let ogTitle = params.ogTitle || title;
    let ogDescription = params.ogDescription || description;
    let ogImage = params.ogImage || '';
    
    let twitterCard = params.twitterCard || 'summary';
    
    // Convert the schemaMarkup JSON object into a string for the <script> tag
    const schemaString = schema ? JSON.stringify(schema) : null;
    
    return (
        <HelmetProvider>
            <Helmet>
                {/* Basic SEO Tags */}
                    <title>{title}</title>
                    <meta name="description" content={description} />
                    <meta name="keywords" content={keywords} />
                    <link rel="canonical" href={canonicalUrl} />
                    <meta name="robots" content={robots} />
            
                    {/* Open Graph Tags (Facebook, LinkedIn, etc.) */}
                    <meta property="og:type" content={ogType} />
                    <meta property="og:url" content={canonicalUrl} />
                    <meta property="og:title" content={ogTitle} />
                    <meta property="og:description" content={ogDescription} />
                    {ogImage && <meta property="og:image" content={ogImage} />}
            
                    {/* Twitter Card Tags */}
                    <meta name="twitter:card" content={twitterCard || 'summary'} />
                    <meta name="twitter:title" content={ogTitle} />
                    <meta name="twitter:description" content={ogDescription} />
                    {ogImage && <meta name="twitter:image" content={ogImage} />}
            
                    {/* Structured Data (Schema Markup) */}
                    {schemaString && (
                    <script type="application/ld+json">
                        {schemaString}
                    </script>
                )}
        
            </Helmet>
        </HelmetProvider>
    );

}

export const callApi = async (url, reqMethod, moreHeaders, reqBody) => {
        
    let apiRc = {
        disposition: 'retry',     // abort, retry, change, logout, empty, resourceExists
        message: '',              // Sent by the server.
        respBody: {},             // Sent by the server.
        httpStatus: '100',        // Sent by the server.
        
    };


    try {

        const sendBody = ((reqMethod !== 'GET') && (reqMethod !== 'HEAD'));

        let fetchConfig = {
            method: reqMethod,
            headers: {
                'Content-Type': 'application/json',
            }
        };

        if (sendBody) {
            fetchConfig.body = reqBody;
        }

        console.log(fetchConfig);

        //const baseUrl = 'http://192.168.1.220:4001';
        //const baseUrl = 'https://api-us.turbosteed.com';
        const baseUrl = 'https://' + process.env.REACT_APP_API_URL;


        const response = await fetch(baseUrl + url, fetchConfig)
        .then((response) => {
            Tdebug && console.log("In response");
            Tdebug && console.log(response);
            Tdebug && console.log(response.headers);
            Tdebug && console.log(response.data);
            Tdebug && console.log(JSON.stringify(response));
            Tdebug && console.log("In response");

            if (response.ok == false) {

                const httpStatus = response.status;
                return response.json().then((err) => {
                    Tdebug && console.log(err);
                    Tdebug && console.log(err.message);     // This is the actual message.
                    Tdebug && console.log(httpStatus);      // This is the status code.
                    throw new CustomError(err.message, {    // CustomError works.
                        httpCode: httpStatus,
                        messageBody: err || ''
                    });
                })
            }

            return response.json();
        }).then((responseJson) => {
            console.log(responseJson);

            apiRc = {
                disposition: 'success',                // abort, retry, change, logout, empty, resourceExists, success
                message: responseJson.message || '',   // Sent by the server.
                respBody: responseJson || {},          // Sent by the server.
                httpStatus: '200'                      // Sent by the server.
            };

        }).catch((error) => {
            console.log(JSON.stringify(error));

            Tdebug && console.log(JSON.stringify(error));
            Tdebug && console.log(error);
            Tdebug && console.log(error.errJson.httpCode);     // This works.
            Tdebug && console.log(error.errJson.messageBody);  // This works.

            switch (error.errJson.httpCode)
            {
                case 401:
                    apiRc = {
                        disposition: 'logout',                              // abort, retry, change, logout, empty, resourceExists
                        message: error.errJson.messageBody.message || '',   // Sent by the server.
                        respBody: error.errJson.messageBody || {},                 // Sent by the server.
                        httpStatus: error.errJson.httpCode                  // Sent by the server.
                    };
                    break;

                case 405:
                case 410:
                case 409:
                case 400:
                    // Cannot be recovered unless code is changed.    
                    apiRc = {
                        disposition: 'change',                              // abort, retry, change, logout, empty, resourceExists
                        message: error.errJson.messageBody.message || '',   // Sent by the server.
                        respBody: error.errJson.messageBody  || {},         // Sent by the server.
                        httpStatus: error.errJson.httpCode,                 // Sent by the server.

                    };

                    break;

                case 410:
                    // Cannot be recovered unless code is changed.   


                    apiRc = {
                        disposition: 'resourceExists',                      // abort, retry, change, logout, empty, resourceExists
                        message: error.errJson.messageBody.message || '',   // Sent by the server.
                        respBody: error.errJson.messageBody || {},         // Sent by the server.
                        httpStatus: error.errJson.httpCode,                 // Sent by the server.

                    };
                    break;



                case 404:
                    // Not found.
                    console.log("In not found switch case");
                    apiRc = {
                        disposition: 'empty',                               // abort, retry, change, logout, empty, resourceExists
                        message: error.errJson.messageBody.message || '',   // Sent by the server.
                        respBody: error.errJson.messageBody || {},      // Sent by the server.           
                        httpStatus: error.errJson.httpCode,                 // Sent by the server.

                    };
                    break;

                case 500:
                case 502:
                default:


                        // Retry:
                        apiRc = {
                            disposition: 'retry',                               // abort, retry, change, logout, empty, resourceExists
                            message: error.errJson.messageBody.message || '',   // Sent by the server.
                            respBody: error.errJson.messagBody || {},         // Sent by the server.
                            httpStatus: error.errJson.httpCode,                 // Sent by the server.

                        };

                        break;
                }
            });
        } catch (fetchErr) {
            Tdebug && console.log(fetchErr);

            apiRc = {
                disposition: 'retry',       // abort, retry, change, logout, empty, resourceExists
                message: 'network error',
                respBody: {},
                httpStatus: 500,
            };
        }

        return apiRc;

}

//
// Store UTM parameters in a cookie
//
export const storeUtm = () => {

	// Don't store the cookie if its already set.
	const match = document.cookie.match(/tdc=([^;]+)/);
	if (match) {
      		return null;
	}

	const urlParams = new URLSearchParams(window.location.search);
	const trackingData = {
		utm_source: urlParams.get('utm_source'),
		utm_medium: urlParams.get('utm_medium'),
		utm_campaign: urlParams.get('utm_campaign'),
		affiliate_id: urlParams.get('affiliate_id'),
		timestamp: Date.now()
	};

	// Set cookie accessible to all subdomains - set for 30 days.
	// tracking data cookie = tdc
	document.cookie = `tdc=${encodeURIComponent(JSON.stringify(trackingData))}; domain=.turbosteed.com; path=/; max-age=2592000; Secure; SameSite=Lax`;



}
